import React, { Component } from "react";
import {
    NavBar,
    Icon,
    List,
    Button,
    WhiteSpace,
    WingBlank,
    Pagination,
    InputItem,
    Toast,
    SearchBar,
    ActionSheet,
} from "antd-mobile";
import { Link } from "react-router-dom";
import "../admin.scss";
import { createForm } from "rc-form";
import { connect } from "dva";
import axios from "../../../service/axios";

const Item = List.Item;
const Brief = Item.Brief;
const selectedContainer = {
    position: "fixed",
    width: "100%",
    top: "45px",
    background: "#f5f5f5",
    height: "100%",
    zIndex: "11",
    transition: "left 0.4s",
};
const plus_icon = require("../../../assets/images/icon/plus_icon.png");
@connect(({ admin }) => ({ admin }))
export class adminRetrieve extends Component {
    state = {
        retrieveAdminList: [],
        pageNo: 1,
        pageTotalNum: 0,
        drawerLeft: document.body.clientWidth,
        loginName: "",
        uid: "",
    };
    componentDidMount() {
        this.getRetrieveAdminList(1);
    }
    componentWillUnmount() {
        this.setState = (state, callback) => {
            return;
        };
    }
    getRetrieveAdminList(page, loginName) {
        this.props
            .dispatch({
                type: "admin/getRetrieveAdminList",
                payload: {
                    page: {
                        pageNo: page,
                        pageSize: 10,
                    },
                    loginName,
                },
            })
            .then(res => {
                if (res) {
                    this.setState({
                        drawerLeft: document.body.clientWidth,
                    });
                }
            });
    }
    onPageChange(e) {
        const { pageTotalNum } = this.props.admin;
        e = e > pageTotalNum ? pageTotalNum : e;
        this.getRetrieveAdminList(e);
    }
    onOpenChange = () => {
        this.setState({
            drawerLeft: 0,
        });
    };
    onInfoAccountId = e => {
        this.setState({
            uid: e,
        });
    };
    onInfoAccountName = e => {
        console.log(e);
        this.setState({
            loginName: e,
        });
    };
    onSearch = () => {
        this.props.form.validateFields({ force: false }, error => {
            this.getRetrieveAdminList(1, this.props.form.getFieldsValue().loginName);
            this.setState({
                drawerLeft: document.body.clientWidth,
            })
        });
    };
    onSearchAll = () => {
        this.setState({
            loginName: null,
            uid: null,
        });
        setTimeout(() => {
            this.getRetrieveAdminList(1);
            this.setState({
                drawerLeft: document.body.clientWidth,
            })
        }, 0);
    };
    handleRecover(adminId) {
        const BUTTONS = ["确定", "取消"];
        ActionSheet.showActionSheetWithOptions(
            {
                options: BUTTONS,
                message: "确定还原管理员吗？",
                maskClosable: true,
            },
            buttonIndex => {
                if (!buttonIndex) {
                    axios
                        .get("/api/user/admin/recover", {
                            params: {
                                adminId,
                            },
                        })
                        .then(res => {
                            if (res) {
                                if (res.status == 200) {
                                    this.getRetrieveAdminList(1);
                                } else {
                                    Toast.fail(res.message, 1);
                                }
                            }
                        });
                }
            },
        );
    };
    render() {
        const { drawerLeft, loginName } = this.state;
        const { admin } = this.props;
        const { retrieveAdminList, pageTotalNum, pageNo } = admin;
        const { getFieldProps } = this.props.form;

        return (
            <div className="adminList">
                <div className="header-sticky">
                    <NavBar
                        icon={<Icon type="left" />}
                        onLeftClick={() => this.props.history.goBack()}
                        rightContent={[
                            <Icon
                                key="0"
                                type="search"
                                onClick={this.onOpenChange}
                                style={{ marginRight: "16px" }}
                            />,
                        ]}
                    >
                        回收管理员
                    </NavBar>
                </div>
                <div className="sub-container">
                    <List className="my-list">
                        {retrieveAdminList.map((i, index) => (
                            <Item
                                key={index}
                                arrow="horizontal"
                                multipleLine
                                onClick={() => this.handleRecover(i.id)}
                            >
                                登录账号： {i.loginName}{" "}
                                &ensp;&ensp;&ensp;账号ID: {i.uid}
                            </Item>
                        ))}
                    </List>
                    <WhiteSpace />
                    <WingBlank>
                        <SearchBar
                            placeholder="请输入跳转页面"
                            onSubmit={value => this.onPageChange(value)}
                        />
                    </WingBlank>
                    <WhiteSpace />
                    <WingBlank>
                        {pageTotalNum > 0 ? (
                            <Pagination
                                total={pageTotalNum}
                                current={pageNo}
                                locale={{
                                    prevText: "上一页",
                                    nextText: "下一页",
                                }}
                                onChange={e => this.onPageChange(e)}
                            />
                        ) : (
                                ""
                            )}
                    </WingBlank>
                </div>
                <div style={{ ...selectedContainer, left: drawerLeft }}>
                    <List renderHeader="搜索管理员">
                        <InputItem
                            {...getFieldProps("loginName", {
                                initialValue: loginName,
                            })}
                            clear
                            onChange={e => this.onInfoAccountName(e)}
                            placeholder="请输入账号"
                            key="1"
                        >
                            账号
                        </InputItem>
                        <Item>
                            <Button type="primary" onClick={this.onSearch}>
                                确定
                            </Button>
                            <WhiteSpace size="lg" />
                            <Button type="primary" onClick={this.onSearchAll}>
                                全部
                            </Button>
                            <WhiteSpace size="lg" />
                            <Button
                                onClick={() =>
                                    this.setState({
                                        drawerLeft: document.body.clientWidth,
                                    })
                                }
                            >
                                返回
                            </Button>
                        </Item>
                    </List>
                </div>
            </div>
        );
    }
}

export default createForm()(adminRetrieve);
